// Mock data for Sen&Co website

export const companyInfo = {
  name: "Sen & Company",
  tagline: "",
  since: 1992,
  logo: "https://customer-assets.emergentagent.com/job_2ac85a77-7d98-4819-899f-164393cc1467/artifacts/ik0w9xzl_Sen%20Logo%20PNG.png",
  contact: {
    address: "130 Balaram Dey Street, Near Girish Park Metro Station, Kolkata – 700006",
    contactName: "Pijush Paul",
    phone: "9051922724",
    email: "senpower.bmgp@gmail.com",
    mapCoords: { lat: 22.5726, lng: 88.3639 } // Girish Park Metro Station area
  }
};

export const homeContent = {
  hero: {
    headline: "Powering Mobility. Strengthening Markets. Building Trust.",
    subheadline: "Sen & Company is a leading automotive and energy solutions distributor headquartered in Kolkata, with a deep-rooted presence across West Bengal.",
    description: "We connect trusted global and Indian brands with a strong sub-dealer and retailer ecosystem, ensuring reliable availability, market reach and sustained growth."
  },
  vision: {
    title: "Our Vision",
    content: "To be the most trusted and preferred distributor for automotive and energy solutions across Eastern India, empowering mobility and sustainability through reliable products and partnerships."
  },
  mission: {
    title: "Our Mission",
    content: "To connect world-class energy brands with local markets through an extensive dealer and retailer network, ensuring product availability, technical support, and after-sales excellence while building long-term partnerships based on trust and mutual growth."
  },
  philosophy: {
    title: "Our Philosophy",
    description: "We believe distribution is not just logistics — it is about:",
    points: [
      "Market development",
      "Relationship building",
      "Service excellence",
      "Sustainable growth"
    ],
    footer: "Every dealer, retailer and partner we work with is treated as a long-term stakeholder in our success."
  },
  whyUs: [
    "Established distributor with deep market knowledge",
    "Strong dealer & retailer network",
    "Multi-brand, multi-segment expertise",
    "Transparent billing & warranty processes",
    "Focus on long-term partnerships, not one-time sales"
  ],
  reach: [
    "Kolkata & Greater Kolkata",
    "North 24 Parganas",
    "Barasat",
    "Baharampur",
    "Expanding footprint across West Bengal"
  ],
  ctas: [
    { label: "Become a Dealer", href: "/contact" },
    { label: "Explore Our Products", href: "/products" },
    { label: "Contact Our Team", href: "/contact" }
  ]
};

export const aboutContent = {
  journey: [
    {
      year: "1992",
      title: "The Beginning",
      content: "On 15th August 1992, the journey of Sen and Company began in Girish Park, Kolkata, in a small 200 sq. ft. space. It was started by a 22-year-old young man, Mr. Surajit Sen, whose initiative, enthusiasm, and strong spirit made everything possible."
    },
    {
      year: "1992-1999",
      title: "Building Foundation",
      content: "Started as a private dealer of Exide batteries, receiving many awards including the Exide Sen and Company Chairman's Club Dealer Award for outstanding performance."
    },
    {
      year: "1998-1999",
      title: "New Partnership",
      content: "Standard Furukawa joined Exide Industries Ltd. and Sen & Co became the dealer of Standard Furukawa, handling distribution of SF-automotive and industrial batteries."
    },
    {
      year: "1999-2012",
      title: "Growth & Recognition",
      content: "For five years in a row, received the award for being the Number 1 automotive battery seller in the entire Eastern region of India & Number 1 SF industrial battery distributor on all India. Introduced the logo 'Power and Parampara'."
    },
    {
      year: "2011",
      title: "New Ventures",
      content: "Started a new chapter with the IDEAL brand's inverter tubular batteries. This brand was introduced by Sen and Company itself, gaining recognition along with its E-rickshaw batteries."
    },
    {
      year: "2015-2023",
      title: "Expansion",
      content: "Worked as inverter distributor for Luminous (2015-2023). Partnered with TATA Green Batteries (2012-2025), becoming one of the top sellers in India. First branch opened in Baharampur."
    },
    {
      year: "Present",
      title: "Current Operations",
      content: "Dealing with Surya brand E-rickshaw batteries, Selenide automotive and tubular batteries, and Gulf two-wheeler battery distribution."
    }
  ],
  philosophy: {
    title: "Our Philosophy",
    description: "We believe distribution is not just logistics — it is about:",
    points: [
      "Market development",
      "Relationship building",
      "Service excellence",
      "Sustainable growth"
    ],
    footer: "Every dealer, retailer and partner we work with is treated as a long-term stakeholder in our success."
  },
  whatSetsUsApart: [
    "Multi-brand portfolio across conventional & new-age energy",
    "Structured dealer support for billing, warranty & service",
    "Strong ground presence with market intelligence",
    "Commitment to ethical business practices",
    "Focus on mobility & sustainability"
  ]
};

export const brandsData = {
  gulf: {
    name: "Gulf Batteries",
    logo: "https://customer-assets.emergentagent.com/job_2ac85a77-7d98-4819-899f-164393cc1467/artifacts/66gg8e2s_Gulf_logo.png",
    productImage: "https://customer-assets.emergentagent.com/job_senco-showcase/artifacts/ndxzjhx9_Gulf_TwoWheeler_battery_range.png",
    tagline: "Trusted Power from a Global Brand",
    description: "Gulf Batteries bring global brand credibility with products designed for two-wheelers, maintenance free and VRLA battery solutions and automotive applications.",
    benefits: [
      "Strong cranking power",
      "Reliable start performance",
      "Maintenance-free options",
      "Backed by nationwide brand presence"
    ],
    support: [
      "Dealer onboarding",
      "Market development support",
      "Warranty coordination",
      "Retailer engagement activities"
    ],
    segment: "Two Wheeler",
    ctas: [
      { label: "Enquire for Gulf Dealership", href: "/contact", type: "primary" }
    ]
  },
  surya: {
    name: "Surya Batteries",
    logo: "https://customer-assets.emergentagent.com/job_2ac85a77-7d98-4819-899f-164393cc1467/artifacts/0ede2u5k_Surya_logo.png",
    productImage: "https://customer-assets.emergentagent.com/job_senco-showcase/artifacts/v7xgeqh2_SuryaE_Rickshaw_battery.png",
    brochureUrl: "https://customer-assets.emergentagent.com/job_senco-showcase/artifacts/kiizw3ml_Product%20Brochure_Surya.pdf",
    tagline: "Powering Trust Since 1998",
    description: "Surya Batteries is an ISO 9001:2015 certified company and a trusted name in the Lead Acid Battery manufacturing industry since 1998. Delivering high-performance batteries for UPS & Inverter systems, Solar power, E-Rickshaws, and Automotive segments.",
    features: [
      "Crafted with precision and tested for durability",
      "Designed for deep cycle performance regardless of discharge depth",
      "Equipped with special grid alloys to minimize water loss and corrosion",
      "Built to operate even in sluggish weather conditions",
      "Assembled in heat-sealed polypropylene containers for leak-proof, vibration-resistant performance"
    ],
    whyChoose: [
      "25+ years experience in battery manufacturing & energy storage",
      "Conscious visionary of environment and livelihood",
      "High efficiency in manufacturing",
      "Continuous up-gradation & adoption of new technologies",
      "Lean management with 35+ years of industrial experience",
      "Personalized customer services with strong employee attitude",
      "Product and process innovations"
    ],
    segment: "E-Rickshaw (Mera Dost)",
    segmentBenefits: [
      "High mileage & higher capacity",
      "Rugged design for commercial usage",
      "Stable performance even under heavy load cycles"
    ],
    idealFor: "Ideal for dealers, fleet operators & e-rickshaw assemblers",
    support: [
      "Dealer onboarding",
      "Market development support",
      "Warranty coordination",
      "Retailer engagement activities"
    ],
    ctas: [
      { label: "Enquire for Surya Dealership", href: "/contact", type: "primary" },
      { label: "Download Product Brochure", href: "https://customer-assets.emergentagent.com/job_senco-showcase/artifacts/kiizw3ml_Product%20Brochure_Surya.pdf", type: "download" }
    ]
  },
  selenide: {
    name: "Selenide",
    logo: "https://customer-assets.emergentagent.com/job_176ab01e-388f-4bea-9c6b-49caaa144cc8/artifacts/ixjx62a6_Selenide-SquareLogo.png",
    productImage: "https://customer-assets.emergentagent.com/job_senco-showcase/artifacts/6ixh7pls_Selenide_Product_Range.png",
    tagline: "Promise of Power",
    description: "Selenide Technologies Private Limited is an Indian origin storage Battery manufacturing company headquartered at Pune, India. Selenide is a manufacturer of Lead Acid storage batteries and power storage solutions provider in India.",
    portfolio: [
      { name: "Passenger cars", url: "https://selenide.in/passenger-car-batteries/" },
      { name: "LCV (Light Commercial Vehicles)", url: "https://selenide.in/lcv-batteries/" },
      { name: "HCV (Heavy Commercial Vehicles)", url: "https://selenide.in/hcv-batteries/" },
      { name: "Tractor", url: "https://selenide.in/tractor-batteries/" },
      { name: "Solar", url: null },
      { name: "E-rickshaw segment", url: "https://selenide.in/e-rickshaw-batteries/" },
      { name: "Tubular batteries for inverter segment", url: "https://selenide.in/inverter-batteries/" }
    ],
    support: [
      "Dealer onboarding",
      "Market development support",
      "Warranty coordination",
      "Retailer engagement activities"
    ],
    segment: "Automotive, Inverter & Solar",
    externalLinks: [
      { label: "Automotive Batteries", url: "https://selenide.in/automotive-batteries/" },
      { label: "Inverter Batteries", url: "https://selenide.in/inverter-batteries/" }
    ],
    ctas: [
      { label: "Stock Our Products", href: "/contact", type: "primary" },
      { label: "Dealership Opportunities", href: "/contact", type: "secondary" }
    ]
  }
};

export const galleryCategories = [
  { id: "dealer-meets", label: "Dealer & Retailer Meets" },
  { id: "product-launches", label: "Product Launches" },
  { id: "brand-collaborations", label: "Brand Collaborations" },
  { id: "market-activations", label: "Market Activations" },
  { id: "team-events", label: "Team & Partner Engagements" }
];

export const galleryImages = [];

export const newsItems = [
  {
    id: 1,
    title: "Sen & Co Partners with Selenide for Battery Distribution",
    date: "December 9, 2024",
    excerpt: "Sen & Co successfully hosted a launch event bringing together channel partners, announcing the collaboration with Selenide Technologies for automotive, inverter and solar battery distribution across West Bengal. This partnership reinforces our commitment to expanding our product portfolio and providing comprehensive energy solutions to our dealer network.",
    featured: true,
    category: "Partnership"
  }
];

export const navigationLinks = [
  { label: "Home", href: "/" },
  { label: "About Us", href: "/about" },
  { label: "Products", href: "/products" },
  { label: "Gallery", href: "/gallery" },
  { label: "Contact Us", href: "/contact" }
];
